<template>
  <div class="h-full w-[1px] bg-secondaryGray"></div>
</template>
